import api from "./api";
import { SELECTED_RESTAURANT_ID_KEY } from "./constants";


const getRestaurantIdFromPathname = () => {
  if (typeof window === "undefined") return null;

  const match = window.location.pathname.match(
    /\/restaurant-management\/(?:menu|orders)\/([^/?#]+)/i
  );

  return match?.[1] || null;
};

const getSelectedRestaurantId = () => {
  const storedId = localStorage.getItem(SELECTED_RESTAURANT_ID_KEY);
  if (storedId) return storedId;

  const pathId = getRestaurantIdFromPathname();
  if (pathId) {
    localStorage.setItem(SELECTED_RESTAURANT_ID_KEY, pathId);
    return pathId;
  }

  return null;
};

const shouldAttachRestaurantId = (url = "") => {
  if (!url.includes("/restaurant-management")) return false;

  // Restaurant listing endpoint does not require restaurant context.
  return !url.endsWith("/restaurant-management/restaurants");
};

// Add request interceptor to include token and selected restaurant context.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (shouldAttachRestaurantId(config.url || "")) {
      const restaurantId = getSelectedRestaurantId();
      if (restaurantId) {
        config.headers["x-restaurant-id"] = restaurantId;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
